'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _ = require('../../');

var _fbemitter = require('fbemitter');

require('./dialog.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoDialog = function (_Component) {
    _inherits(GeckoDialog, _Component);

    function GeckoDialog(props) {
        _classCallCheck(this, GeckoDialog);

        // Create toast event emitter (if not already created)
        var _this = _possibleConstructorReturn(this, (GeckoDialog.__proto__ || Object.getPrototypeOf(GeckoDialog)).call(this, props));

        _this.state = {
            modal: false,
            content: null,
            type: null,
            params: {}
        };
        if (!_.GeckoDialogService.emitter) _.GeckoDialogService.emitter = new _fbemitter.EventEmitter();

        // Listen for open trigger
        _.GeckoDialogService.emitter.addListener('open', function (content, type, params) {
            _this.setState({
                modal: true,
                content: content,
                type: type,
                params: params
            });
        });

        // Listen for close trigger
        _.GeckoDialogService.emitter.addListener('close', function () {
            _this.setState({
                modal: false,
                content: null,
                type: null,
                params: {}
            });
        });
        return _this;
    }

    _createClass(GeckoDialog, [{
        key: 'renderBtns',
        value: function renderBtns() {
            var btns = [{
                name: 'OK',
                primary: true,
                handler: function handler() {
                    return _.GeckoDialogService.emitter.emit('close', true);
                }
            }];

            if (this.state.type === _.GECKO_CONSTS.DIALOG_TYPE_CONFIRM) {
                btns.push({
                    name: 'Cancel',
                    secondary: true,
                    handler: function handler() {
                        return _.GeckoDialogService.emitter.emit('close', false);
                    }
                });
            }

            return btns;
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.modal) return null;
            return _react2.default.createElement(
                _reactstrap.Modal,
                {
                    isOpen: this.state.modal,
                    toggle: function toggle() {},
                    size: this.state.params.size,
                    backdrop: this.state.params.backdrop,
                    keyboard: this.state.params.keyboard,
                    wrapClassName: 'gecko-modal-wrapper gecko-dialog',
                    fade: false },
                _react2.default.createElement(
                    _.GeckoModal,
                    { btns: this.renderBtns(), fields: [], values: {} },
                    this.state.content ? this.state.content : null
                )
            );
        }
    }]);

    return GeckoDialog;
}(_react.Component);

exports.default = GeckoDialog;
